import { PureComponent } from 'preact-compat'
import Phrase from '../../../libs/translationsUtils/phrase'

export interface ReportPrivateMessageButtonProps {
  onReport: () => void
}

class ReportPrivateMessageButton extends PureComponent<ReportPrivateMessageButtonProps> {
  render() {
    const { onReport } = this.props
    return (
      <div className='qa-private-message-report' onClick={onReport}>
        <Phrase p='privateMessages.conversation.reportButton' />
      </div>
    )
  }
}

export default ReportPrivateMessageButton
